import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: VideoObject → /cases
export const Route = createFileRoute("/video-object")({
  beforeLoad: () => {
    throw redirect({ to: "/cases", replace: true });
  },
  component: () => null,
});
